import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

interface DraftDetail {
  id: string;
  memberId: string;
  name: string;
  content: string;
  sourceFormId: string | null;
  createdAt: string;
  updatedAt: string;
}

interface GetDraftsRequest {
  limit: number;
  offset: number;
  count?: boolean;
  keyword?: string;
  assigned?: boolean;
}

export interface GetDraftsResponse {
  count: number;
  drafts: Array<{
    id: string;
    memberId: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  }>;
}

export function getDrafts(workspaceId: string, { keyword, assigned, ...params }: GetDraftsRequest) {
  return requestApi<GetDraftsResponse>({
    url: withForm(`/workspaces/${workspaceId}/drafts`),
    method: 'GET',
    credentials: true,
    params: {
      ...params,
      filter: {
        keyword,
        assigned,
      },
    },
  }).then((res) => res.data);
}

export interface CreateDraftRequest {
  name: string;
  content: string;
  form?: string;
}

export function createDraft(workspaceId: string, data: CreateDraftRequest) {
  return requestApi<DraftDetail>({
    url: withForm(`/workspaces/${workspaceId}/drafts`),
    method: 'POST',
    credentials: true,
    data,
  }).then((res) => res.data);
}

export function getDraft(workspaceId: string, draftId: string) {
  return requestApi<DraftDetail>({
    url: withForm(`/workspaces/${workspaceId}/drafts/${draftId}`),
    method: 'GET',
    credentials: true,
  }).then((res) => res.data);
}

interface EditDraftRequest {
  id: string;
  name: string;
  content: string;
}

export function editDraft(workspaceId: string, data: EditDraftRequest) {
  return requestApi<DraftDetail>({
    url: withForm(`/workspaces/${workspaceId}/drafts/${data.id}`),
    method: 'PUT',
    credentials: true,
    data,
  }).then((res) => res.data);
}

export function deleteDraft(workspaceId: string, draftId: string) {
  return requestApi({
    url: withForm(`/workspaces/${workspaceId}/drafts/${draftId}`),
    method: 'DELETE',
    credentials: true,
  });
}

interface BulkDeleteDraftsData {
  draftIds: string[];
}
interface BulkDeleteDraftsResponse {
  error: number;
  results: {
    id: string | null;
    data: null;
    error: {
      type: string | null;
      title: string | null;
      detail: string | null;
      instance: string | null;
      data: Record<string, unknown>;
    } | null;
  }[];
}
export function bulkDeleteDrafts(workspaceId: string, data: BulkDeleteDraftsData) {
  return requestApi<BulkDeleteDraftsResponse>({
    url: withForm(`/bulk/workspaces/${workspaceId}/drafts/remove`),
    method: 'POST',
    credentials: true,
    data,
  }).then((res) => res.data);
}
